export const ROOT = '/'
export const SPEAKERS = '/speakers'
export const LOGIN = '/login'
export const DASHBOARD = '/dashboard'
export const REGISTER = '/register'
export const ASSISTANTS = '/assistants'